import { render } from "./AboutIntroduce.vue?vue&type=template&id=7446bc16&scoped=true"
import script from "./AboutIntroduce.vue?vue&type=script&lang=js"
export * from "./AboutIntroduce.vue?vue&type=script&lang=js"

import "./AboutIntroduce.vue?vue&type=style&index=0&id=7446bc16&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7446bc16"]])

export default __exports__